@if(!hideFooter){
<div>
    @if(footerVariant){
    <div>
 


        @if(footerVariant == 'footer-five'){
        <div>
            <!-- Footer Start -->
            <footer class="footer">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-12">
                            <div class="footer-py-60 text-center">
                                <div class="row py-5">
                                    <div class="col-md-4">
                                        <div
                                            class="card border-0 text-center features feature-primary feature-clean bg-transparent">
                                            <div class="icons text-center mx-auto">
                                                <i class="uil uil-phone d-block rounded h3 mb-0"></i>
                                            </div>
                                            <div class="content mt-4">
                                                <h5 class="footer-head">{{'Phone' | translate}}</h5>
                                              
                                                <a href="tel:+152534-468-854" class="text-foot" *ngIf="contactUs && contactUs.length > 0">{{contactUs[0].Phone}}</a>
                                            </div>
                                        </div>
                                    </div><!--end col-->

                                    <div class="col-md-4 mt-4 mt-sm-0 pt-2 pt-sm-0">
                                        <div
                                            class="card border-0 text-center features feature-primary feature-clean bg-transparent">
                                            <div class="icons text-center mx-auto">
                                                <i class="uil uil-envelope d-block rounded h3 mb-0"></i>
                                            </div>
                                            <div class="content mt-4">
                                                <h5 class="footer-head">{{'Email' | translate}}</h5>
                                               
                                                <a href="mailto:contact@example.com"
                                                    class="text-foot" *ngIf="contactUs && contactUs.length > 0">{{contactUs[0].Email}}</a>
                                            </div>
                                        </div>
                                    </div><!--end col-->

                                    <div class="col-md-4 mt-4 mt-sm-0 pt-2 pt-sm-0">
                                        <div
                                            class="card border-0 text-center features feature-primary feature-clean bg-transparent">
                                            <div class="icons text-center mx-auto">
                                                <i class="uil uil-map-marker d-block rounded h3 mb-0"></i>
                                            </div>
                                           <div class="content mt-4">
                                              <h5 class="footer-head">{{'Address'|translate}}</h5>
                                              <a href="https://www.google.com/maps/@29.98272,31.2475648,13z?entry=ttu&g_ep=EgoyMDI2MDcyNi4wIKXMDSoASAFQAw%3D%3D"
                                                data-type="iframe" 
                                                class="video-play-icon text-foot lightbox"
                                                *ngIf="contactUs && contactUs.length > 0">
                                                {{currentLang === 'ar' ? contactUs[0].AddressAr : contactUs[0].AddressEn }}
                                              </a>
                                            </div>
                                        </div>
                                    </div><!--end col-->
                                </div><!--end row-->
                            </div>
                        </div><!--end col-->
                    </div><!--end row-->
                </div><!--end container-->

                <div class="footer-py-30 footer-bar bg-footer">
                    <div class="container">
                        <div class="row  justify-content-between">
                         

                            <div class="col-lg-6 col-md-6 col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0" >
                                <ul class="list-unstyled footer-list terms-service mb-0">
                                    <li class="list-inline-item mb-0"><a routerLink="/Privacy"
                                            class="text-foot me-2">{{'Privacy' | translate}}</a></li>
                                    <li class="list-inline-item mb-0"><a routerLink="/Terms"
                                            class="text-foot me-2">{{'Terms' | translate}}</a></li>
                                    <li class="list-inline-item mb-0"><a routerLink="/faqs"
                                            class="text-foot me-2">{{'FAQs' | translate}}</a></li>
                                    <li class="list-inline-item mb-0"><a routerLink="/contact"
                                            class="text-foot">{{'Contact' | translate}}</a></li>
                                </ul>
                            </div><!--end col-->

                            <div class="col-lg-6 col-md-6 col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                                <div class="text-sm-end">
                                    <!-- <p class="mb-0 text-foot">Copyright ©
                                        {{year}}
                                        <a href="javascript:void(0)" class="text-reset">Easy Wash</a>.
                                        Designed with  by <a href="javascript:void(0)" class="text-reset">Future Core</a>. All rights reserved
                                    </p> -->
                                     <p class="mb-0 text-foot">  © <span id="year">{{ year }}</span> <a
                                            href="javascript:void(0);" class="text-primary"> {{'Easy Wash' | translate}}</a>.
                                         <span class="bi bi-heart-fill text-danger"></span> {{'Powered by' | translate}}  <a href="https://futurecore.net">
                                            {{'Future Core' | translate}}
                                        </a> 
                                        {{'All rights reserved' | translate}}
                                    </p>
                                </div>
                            </div><!--end col-->
                        </div><!--end row-->
                    </div><!--end container-->
                </div>
            </footer>
            <!-- Footer End -->
        </div>
        }

    </div>
    }@else{
    <div>
        <footer class="footer">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="footer-py-60">
                            <div class="row">
                                <div class="col-lg-4 col-12 mb-0 mb-md-4 pb-0 pb-md-2">
                                    <a href="javascript:void(0)" class="logo-footer">
                                        <img src="assets/images/logo-light.png" height="50" alt="">
                                    </a>
                                    <p class="mt-4"> {{'From pickup to delivery, we handle your laundry with care and precision — clean, fresh, and folded to perfection, right on your schedule.' | translate }} </p>
                                    <ul class="list-unstyled social-icon foot-social-icon mb-0 mt-4" *ngIf="contactUs && contactUs.length > 0">
                                        <li class="list-inline-item ms-1"><a href="{{contactUs[0].Facebook}}" class="rounded">
                                                <i-feather name="facebook" class="fea icon-sm fea-social"></i-feather>
                                            </a></li>
                                        <li class="list-inline-item ms-1"><a href="{{contactUs[0].Instagram}}" class="rounded">
                                                <i-feather name="instagram" class="fea icon-sm fea-social"></i-feather>
                                            </a></li>
                                        <li class="list-inline-item ms-1"><a href="{{contactUs[0].Twitter}}" class="rounded">
                                                <i-feather name="twitter" class="fea icon-sm fea-social"></i-feather>
                                            </a></li>
                                        <li class="list-inline-item ms-1"><a href="{{contactUs[0].LinkedIn}}" class="rounded">
                                                <i-feather name="linkedin" class="fea icon-sm fea-social"></i-feather>
                                            </a></li>
                                    </ul>
                                    <!--end icon-->
                                </div>
                                <!--end col-->

                                <div class="col-lg-2 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                                    <h5 class="footer-head">{{'Easy Wash' |translate}} </h5>
                                    <ul class="list-unstyled footer-list mt-4">
                                        <li><a routerLink="/aboutus" class="text-foot">
                                            <i class="uil uil-angle-right-b me-1" *ngIf="currentLang != 'ar'"></i>
                                            <i class="uil uil-angle-left-b me-1" *ngIf="currentLang == 'ar'"></i>
                                                {{'About' | translate}}</a></li>
                                        <li><a routerLink="/services" class="text-foot">
                                           <i class="uil uil-angle-right-b me-1" *ngIf="currentLang != 'ar'"></i>
                                            <i class="uil uil-angle-left-b me-1" *ngIf="currentLang == 'ar'"></i>
                                                {{'Our Services' | translate}} </a></li>
                                        <li><a routerLink="/blogs" class="text-foot">  
                                            <i class="uil uil-angle-right-b me-1" *ngIf="currentLang != 'ar'"></i>
                                            <i class="uil uil-angle-left-b me-1" *ngIf="currentLang == 'ar'"></i>
                                               {{'Blogs' | translate}} </a></li>
                                        <li><a routerLink="/projects" class="text-foot">  <i class="uil uil-angle-right-b me-1" *ngIf="currentLang != 'ar'"></i>
                                            <i class="uil uil-angle-left-b me-1" *ngIf="currentLang == 'ar'"></i>
                                                {{'Our Projects' | translate }} </a></li>
                                        <li><a routerLink="/contact" class="text-foot">  <i class="uil uil-angle-right-b me-1" *ngIf="currentLang != 'ar'"></i>
                                            <i class="uil uil-angle-left-b me-1" *ngIf="currentLang == 'ar'"></i> {{ 'Contact' | translate }} </a></li>
                                 
                                    </ul>
                                </div>
                              
                                <div class="col-lg-3 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                                    <h5 class="footer-head">{{'Privacy' | translate}}</h5>
                                    <ul class="list-unstyled footer-list mt-4">
                                        <li><a routerLink="/Privacy" class="text-foot">  <i class="uil uil-angle-right-b me-1" *ngIf="currentLang != 'ar'"></i>
                                            <i class="uil uil-angle-left-b me-1" *ngIf="currentLang == 'ar'"></i>
                                                {{'Privacy' | translate}}</a></li>
                                        <li><a routerLink="/Terms" class="text-foot">  <i class="uil uil-angle-right-b me-1" *ngIf="currentLang != 'ar'"></i>
                                            <i class="uil uil-angle-left-b me-1" *ngIf="currentLang == 'ar'"></i>
                                                {{'Terms' | translate}}</a></li>
                                        <li><a routerLink="/faqs" class="text-foot">  <i class="uil uil-angle-right-b me-1" *ngIf="currentLang != 'ar'"></i>
                                            <i class="uil uil-angle-left-b me-1" *ngIf="currentLang == 'ar'"></i>
                                                {{'FAQs' | translate}}</a></li>
                           
                                    </ul>
                                </div>
                                <!--end col-->

                                <div class="col-lg-3 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                                    <h5 class="footer-head">{{'Contact' | translate}} </h5>
                                       <ul class="list-unstyled footer-list mt-4" *ngIf="contactUs && contactUs.length > 0">
                                        <li>
                                             <a href="{{contactUs[0].Email}}" class="text-primary">
                                                  <i-feather name="mail" class="fea icon-m-md text-dark me-3"></i-feather>
                                                {{contactUs[0].Email}}</a>
                                        </li>
                                         <li>
                                              <a href="tel:{{contactUs[0].Phone}}" class="text-primary">
                                                <i-feather name="phone" class="fea icon-m-md text-dark me-3"></i-feather>
                                                {{contactUs[0].Phone}}</a>
                                        </li>
                                           <li>
                                              <a  class="text-primary">
                                               <i-feather name="map-pin" class="fea icon-m-md text-dark me-3"></i-feather>
                                                {{currentLang === 'ar' ? contactUs[0].AddressAr : contactUs[0].AddressEn }}</a>
                                        </li>
                                    </ul>
                                   
                                </div>
                                <!--end col-->
                            </div>
                            <!--end row-->
                        </div>
                    </div>
                </div>
            </div>
            <!--end container-->
            <!--end footer-->
            <div class="footer-py-30 footer-bar">
                <div class="container text-center">
                    <div class="row align-items-center">
                        <div class="col-sm-12">
                            <div class="text-sm-start">
                               <p class="mb-0 text-foot" style="text-align:center">  © <span id="year">{{ year }}</span> <a
                                            href="javascript:void(0);" class="text-primary"> {{'Easy Wash' | translate}}</a>.
                                         <span class="bi bi-heart-fill text-danger"></span> {{'Powered by' | translate}}  <a href="https://futurecore.net">
                                            {{'Future Core' | translate}}
                                        </a> 
                                        {{'All rights reserved' | translate}}
                                    </p>
                            </div>
                        </div>
                 
                    </div>
                    <!--end row-->
                </div>
                <!--end container-->
            </div>
            <!--end footer-->
        </footer>
    </div>
    }
</div>
}